const technology = [
  {
    path: '/technology',
    name: 'technology',
    meta: { title: '四川省高新技术企业评估测试', node: 'technology', reviewType: 3 },
    component: () => import('../views/technology/index.vue')
  },
  {
    path: '/technology_evaluation',
    name: 'technology_evaluation',
    meta: { title: '四川省高新技术企业评估测试', node: 'technology', reviewType: 3, childNode: true },
    component: () => import('../views/technology/evaluation.vue')
  },
  {
    path: '/technology_result',
    name: 'technology_result',
    meta: { title: '四川省高新技术企业评估测试', node: 'technology', reviewType: 3 },
    component: () => import('../views/technology/result.vue')
  }
]

export default technology;